
import { mapGetters } from 'vuex'
export default {
  components: {
    Button: () => import('primevue/button')
  },
  props: {
    showMain: {
      type: Boolean,
      default: false
    },
    areFiltersActive: {
      type: Boolean,
      default: false
    },
    posts: {
      type: Object,
      default: () => {}
    },
    sanitizeParams: {
      type: Function,
      required: true
    },
    handleSuggested: {
      type: Function,
      required: true
    },
    loadPage: {
      type: Function,
      required: true
    },
    pages: {
      type: Number,
      required: true
    },
    visiblePages: {
      type: Array,
      required: true
    },
    routeName: {
      type: String,
      required: true
    },
    ea: {
      type: String,
      default: '0'
    },
    routeChanged: {
      type: Boolean,
      default: false
    },
    hasCampaign: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      $gtm: null
    }
  },
  computed: {
    ...mapGetters({
      campaign: 'campaign/getCampaign',
      currentPage: 'radar/getCurrentPage'
    })
  },
  methods: {
    openLink(link) {
      const newWindow = window.open(link, '_blank')
      if (newWindow) {
        newWindow.opener = null
        newWindow.focus()
      }
    },
    emitLoadPage(page) {
      if (this.hasCampaign) {
        console.log('EMIT PAGE')
        this.loadPage(page)
      } else {
        this.$router.push(this.localePath({
          name: this.routeName,
          params: { city: this.$route.params.city || '' },
          query: this.sanitizeParams(false, page)
        }))
      }
    },
    trackCampaign(campaign) {
      this.$gtm.push({
        event: 'click_job_application',
        event_data: {
          company_name: campaign.co_name,
          job_application_name: campaign.title,
          job_application_place: campaign.city,
          is_stage: campaign.contract_type === 8,
          verified: campaign.verified,
          orp: campaign.p2p,
          orp_value: campaign.amountunlock,
          page_url: this.$router.currentRoute.fullPath,
          page_title: document ? document?.title : 'CVing'
        }
      })
    }
  }
}
